module.exports = __webpack_public_path__ + "img/qz.272a7f07.png";